export function convertToFormData (data) {
  const formData = new window.FormData()
  for (const key in data) {
    formData.append(key, data[key])
  }
  return formData
}

const accessTokenKey = 'studentCert.accessToken'
const refreshTokenKey = 'studentCert.refreshToken'

export function removeToken () {
  localStorage.removeItem(accessTokenKey)
  localStorage.removeItem(refreshTokenKey)
}

export function getAccessToken () {
  return localStorage.getItem(accessTokenKey)
}

export function getRefreshToken () {
  return localStorage.getItem(refreshTokenKey)
}

export function setToken (accessToken, refreshToken) {
  localStorage.setItem(accessTokenKey, accessToken)
  localStorage.setItem(refreshTokenKey, refreshToken)
}
